import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from '@react-icons/all-files/fa/FaChevronRight';

export interface BreadcrumbItem {
  label: string;
  to?: string;
  icon?: React.ReactNode;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav style={s.nav} aria-label="breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={index}>
            {index > 0 && (
              <span style={s.separator}>
                <FaChevronRight />
              </span>
            )}
            {item.to && !isLast ? (
              <Link to={item.to} style={s.link}>
                {item.icon && <span style={s.icon}>{item.icon}</span>}
                <span>{item.label}</span>
              </Link>
            ) : (
              <span style={{ ...s.item, ...(isLast ? s.active : {}) }}>
                {item.icon && <span style={s.icon}>{item.icon}</span>}
                <span>{item.label}</span>
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

const s: Record<string, React.CSSProperties> = {
  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    flexWrap: 'wrap',
    fontSize: 13,
    fontFamily: "'Inter','Segoe UI',system-ui,sans-serif",
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    color: '#3b82f6',
    textDecoration: 'none',
    fontWeight: 500,
    transition: 'color 0.15s',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    color: '#64748b',
    fontWeight: 500,
  },
  active: {
    color: '#0f172a',
    fontWeight: 600,
  },
  separator: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 10,
    color: '#cbd5e1',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
  },
};
